module.exports = __webpack_public_path__ + "img/security-icon1.fd93bdd5.svg";